// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"662":"9ca39345","916":"f5ee90f8"}[chunkId] + ".chunk.js";
};